import { Typography, Popper as PopperMui } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Popper = styled(PopperMui)`
  z-index: 2200;
`;

export const Header = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 8px 8px 16px;
  align-items: center;
`;

export const NotReadImportContainer = styled('div')`
  max-height: 300px;
  overflow: auto;
`;

export const NotReadImport = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 0 8px;
  align-items: center;
`;

export const BrokenTypography = styled(Typography)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
`;

export const NotReadImportMain = styled('div')<{ cursorPointer: 1 | 0 }>`
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  padding: 8px 16px;
  align-items: center;
  cursor: ${({ cursorPointer }) => (cursorPointer === 1 ? 'pointer' : 'default')};
`;

export const NotReadImportText = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const ResetReadImports = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;
